import { AppMenuPoint, AppMenuPoints, RedirectService } from '@agilox/common';
import { NavColor, NavColors, NavTranslations } from '@agilox/ui-common';
import { Component, computed, HostListener, inject, input, model, output } from '@angular/core';

@Component({
	selector: 'mobile-app-nav',
	templateUrl: './mobile-app-nav.component.html',
	standalone: false,
})
export class MobileAppNavComponent {
	environment = input<string>('live');
	apps = input(AppMenuPoints, {
		transform: (apps: AppMenuPoint[]) => {
			return this.setUrls(apps);
		},
	});

	navTranslations = input<NavTranslations | undefined>();

	myApp = computed(() => {
		return this.apps().find((app: AppMenuPoint) => app.name === 'my') ?? AppMenuPoints[0];
	});

	_apps = computed(() => {
		return this.apps().filter((app: AppMenuPoint) => app.name !== 'my');
	});

	activeApp = input<AppMenuPoint | undefined>();

	navColor = input<NavColor>(NavColors.Dark);
	open = model<boolean>(false);

	toggled = output<boolean>();

	private redirectService: RedirectService = inject(RedirectService);

	toggle() {
		this.open.set(!this.open());
		this.toggled.emit(this.open());
	}

	@HostListener('window: click', ['$event'])
	@HostListener('window:keydown.escape', ['$event'])
	clickOutside(event?: MouseEvent | KeyboardEvent) {
		const target = event?.target as HTMLElement;
		const isAppNav = target?.closest('#mobile-app-nav');
		if (!isAppNav && this.open()) {
			this.open.set(false);
		}
	}

	private setUrls(apps: AppMenuPoint[]) {
		return apps.map((app: AppMenuPoint) => {
			app.url = this.redirectService.getRedirectAppUrl(app.name, this.environment());
			return app;
		});
	}
}
